import src from "IMAGE";
export default { src, width: 281, height: 88, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAQAAAAEwYbDAAAAPklEQVR42gEzAMz/ACoEHgUeBR4DHgUhCVxUcWEAFikJKggpByYIKxI/M5BFdAAqBB4FHgUeBB4FJyU3cTclrIMHPqqQ/qQAAAAASUVORK5CYII="};
